// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
* NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).  https://openapi-generator.tech  Do not edit the class manually.
*/
export var AccountExternalIdType;
(function (AccountExternalIdType) {
    AccountExternalIdType[AccountExternalIdType["UNKN"] = 0] = "UNKN";
    AccountExternalIdType[AccountExternalIdType["UBCHUBID"] = 1] = "UBCHUBID";
    AccountExternalIdType[AccountExternalIdType["TrialCardHubId"] = 2] = "TrialCardHubId";
    AccountExternalIdType[AccountExternalIdType["MemberNumber"] = 3] = "MemberNumber";
    AccountExternalIdType[AccountExternalIdType["ADLDS"] = 4] = "ADLDS";
    AccountExternalIdType[AccountExternalIdType["MedMemberID"] = 5] = "MedMemberID";
    AccountExternalIdType[AccountExternalIdType["PharMemberID"] = 6] = "PharMemberID";
    AccountExternalIdType[AccountExternalIdType["THIRDPARTYID"] = 7] = "THIRDPARTYID";
    AccountExternalIdType[AccountExternalIdType["ARXRxId"] = 8] = "ARXRxId";
    AccountExternalIdType[AccountExternalIdType["CarePathId"] = 9] = "CarePathId";
    AccountExternalIdType[AccountExternalIdType["VMIPatientId"] = 10] = "VMIPatientId";
    AccountExternalIdType[AccountExternalIdType["PorticoPortalId"] = 11] = "PorticoPortalId";
    AccountExternalIdType[AccountExternalIdType["SiteAccountId"] = 12] = "SiteAccountId";
    AccountExternalIdType[AccountExternalIdType["PatientMckId"] = 13] = "PatientMckId";
    AccountExternalIdType[AccountExternalIdType["RemsId"] = 14] = "RemsId";
    AccountExternalIdType[AccountExternalIdType["MangoActivationId"] = 15] = "MangoActivationId";
    AccountExternalIdType[AccountExternalIdType["PatientPartnerId"] = 16] = "PatientPartnerId";
    AccountExternalIdType[AccountExternalIdType["PartnerPatientId"] = 17] = "PartnerPatientId";
    AccountExternalIdType[AccountExternalIdType["SunovionID"] = 18] = "SunovionID";
    AccountExternalIdType[AccountExternalIdType["PharmaCordPatientId"] = 19] = "PharmaCordPatientId";
    AccountExternalIdType[AccountExternalIdType["IBondId"] = 20] = "IBondId";
    AccountExternalIdType[AccountExternalIdType["IBondEnrollmentId"] = 21] = "IBondEnrollmentId";
})(AccountExternalIdType || (AccountExternalIdType = {}));
//# sourceMappingURL=accountExternalIdType.js.map